export type SampleRange = { start: number; end: number };
export const normalizedSample = (sample: number) => (sample - 128) / 128;

export function clampRange(start: number, span: number, length: number): SampleRange {
  span = Math.min(length, Math.max(Math.min(32, length), span));
  start = Math.min(Math.max(0, start), length - span);
  return { start, end: start + span };
}
export function zoomRange(range: SampleRange, factor: number, length: number): SampleRange {
  const span = Math.min(length, Math.max(Math.min(32, length), (range.end - range.start) / factor));
  return clampRange((range.start + range.end - span) / 2, span, length);
}
export function peakColumns(samples: number[], range: SampleRange, width: number) {
  const spp = (range.end - range.start) / width;
  return Array.from({ length: width }, (_, x) => {
    const start = Math.max(0, Math.floor(range.start + x * spp));
    const end = Math.min(samples.length, Math.ceil(range.start + (x + 1) * spp));
    let min = 255, max = 0;
    for (let i = start; i < end; i++) { min = Math.min(min, samples[i]); max = Math.max(max, samples[i]); }
    return { start, end, min, max };
  });
}
export function samplePoints(samples: number[], range: SampleRange, width: number) {
  const span = range.end - range.start;
  const start = Math.max(0, Math.floor(range.start - .5));
  const end = Math.min(samples.length, Math.ceil(range.end + .5));
  return Array.from({ length: end - start }, (_, offset) => {
    const index = start + offset;
    return { index, x: (index + .5 - range.start) / span * width, level: normalizedSample(samples[index]) };
  });
}
export function backingSize(width: number, height: number, dpr: number) {
  return { width: Math.max(1, Math.ceil(width * dpr)), height: Math.max(1, Math.ceil(height * dpr)) };
}
export function timeTicks(range: SampleRange, rate: number, width: number) {
  const seconds = (range.end - range.start) / rate;
  const desired = seconds / Math.max(2, Math.floor(width / 110));
  const magnitude = 10 ** Math.floor(Math.log10(desired));
  const step = [1, 2, 5, 10].find(value => value * magnitude >= desired)! * magnitude;
  const ticks = [];
  for (let t = Math.ceil(range.start / rate / step) * step; t <= range.end / rate; t += step) {
    ticks.push({ x: (t * rate - range.start) / (range.end - range.start) * 100, label: t.toFixed(Math.max(0, -Math.floor(Math.log10(step)))) + ' s' });
  }
  return ticks;
}
